import { TabletDetails } from '@/models/tablet-details'

export class Tablet {
  id?: string
  mac?: string
  companyId?: string
  details?: TabletDetails

  constructor(params?: Partial<Tablet>) {
    Object.assign(this, params)
  }
}